import { QueryHistoryViewerApp } from "./main";
import { registerComponent } from "lib/components";

registerComponent({ QueryHistoryViewerApp });
